import React, { useMemo, useState } from 'react';
import { Pressable, Text, View, StyleSheet } from 'react-native';
import colors from '../../../../config/colors';

const MonthPicker = ({ onDateChange, selectedMonth: initialSelectedMonth }: { onDateChange: any, selectedMonth?: number }) => {
const [selectedMonth, setSelectedMonth] = useState(initialSelectedMonth || new Date().getMonth() + 1);

    const months = [
        { label: 'מרץ', value: 3 },
        { label: 'פברואר', value: 2 },
        { label: 'ינואר', value: 1 },
        { label: 'יוני', value: 6 },
        { label: 'מאי', value: 5 },
        { label: 'אפריל', value: 4 },
        { label: 'ספטמבר', value: 9 },
        { label: 'אוגוסט', value: 8 },
        { label: 'יולי', value: 7 },
        { label: 'דצמבר', value: 12 },
        { label: 'נובמבר', value: 11 },
        { label: 'אוקטובר', value: 10 },
    ];
    

    const handleOnPress = (month) => {
        setSelectedMonth(month.value);
        onDateChange(month);
    }

    const showMonth = useMemo(() => (month) => {
        const monthObj = months.find(m => m.value === month.value);
        return monthObj ? monthObj.label : '';
        
    }, [selectedMonth]);

    return (

            <View style={styles.monthGrid}>
                {months.map((month, index) => ( 
                    <Pressable key={index} onPress={() => handleOnPress(month)} 
                        style={ ({ hovered }) => [
                            styles.segment,
                            hovered && styles.segmentHover,
                            selectedMonth === month.value && styles.segmentSelected
                    ]}>
                        <Text style={[
                            styles.segmentText,
                            selectedMonth === month.value && { color: 'white', fontWeight: '500' }
                        ]}>
                            {showMonth(month)}
                        </Text>
                    </Pressable>
                ))}
            </View>

    )
};

const styles = StyleSheet.create({
    monthGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(4, 1fr)',
        gap: 12,
        flex: 1,
        paddingHorizontal: 16,
        paddingVertical: 32,
    },
    segmentText: {
        fontSize: 14,
        color: colors.darkGrey,
        fontWeight: '400',
        //fontFamily: 'Rubik',
    },
    segment: {
            flex: 1,
            padding: 10,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 5,
        },
        segmentHover: {
            backgroundColor: colors.iconBG,
        },
        segmentSelected: {
            backgroundColor: colors.datepickerChooseBG,  
        },
});

export default MonthPicker;